module.exports = {"lang":"中文"}


//////////////////
// WEBPACK FOOTER
// ./src/widgets/i18n/zh.json
// module id = H+PV
// module chunks = 85